export * from '@tolgee/web';

var tolgeeApply = function (tolgee, i18n) {
    var updateTranslations = function () {
        tolgee.getAllRecords().forEach(function (_a) {
            var language = _a.language, namespace = _a.namespace, data = _a.data;
            if (i18n.getResourceBundle(language, namespace)) {
                i18n.removeResourceBundle(language, namespace);
                i18n.addResources(language, namespace, Object.fromEntries(data));
            }
        });
    };
    tolgee.on('update', updateTranslations);
    i18n.on('languageChanged', function (lang) {
        if (lang && tolgee.getLanguage() !== lang) {
            tolgee.changeLanguage(lang);
        }
    });
    i18n.tolgee = tolgee;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var tolgeeBackend = function (tolgee) {
    return {
        type: 'backend',
        name: 'TolgeeBackend',
        init: function () { },
        read: function (language, ns, callback) {
            return __awaiter(this, void 0, void 0, function () {
                var translations, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, tolgee.loadRecord({
                                    language: language,
                                    namespace: ns,
                                })];
                        case 1:
                            translations = _a.sent();
                            callback(null, Object.fromEntries(translations));
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            // eslint-disable-next-line no-console
                            console.error(e_1);
                            callback(true);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    };
};

var TOLGEE_PROCESSOR_NAME = 'tolgeeProcessor';
var tolgeeProcessor = function (tolgee) {
    return {
        type: 'postProcessor',
        name: 'tolgeeProcessor',
        process: function (value, key, options) {
            return tolgee.wrap({
                key: key.join('.'),
                defaultValue: options.defaultValue,
                translation: value,
                ns: options.ns,
            });
        },
    };
};

var tolgeeOptions = function (tolgee, options) {
    var _a, _b;
    var processors;
    if (typeof options.postProcess === 'string') {
        processors = [options.postProcess, TOLGEE_PROCESSOR_NAME];
    }
    else if (Array.isArray(options.postProcess)) {
        processors = __spreadArray(__spreadArray([], __read(options.postProcess), false), [TOLGEE_PROCESSOR_NAME], false);
    }
    else {
        processors = [TOLGEE_PROCESSOR_NAME];
    }
    var newOptions = __assign(__assign({}, options), { postProcess: processors, i18nFormat: __assign(__assign({}, options === null || options === void 0 ? void 0 : options.i18nFormat), { 
            // @ts-ignore
            bindI18nStore: 'added ' + ((_a = options.i18nFormat) === null || _a === void 0 ? void 0 : _a.bindI18nStore) || '' }), react: __assign(__assign({}, options === null || options === void 0 ? void 0 : options.react), { 
            // @ts-ignore
            bindI18nStore: 'added ' + ((_b = options.react) === null || _b === void 0 ? void 0 : _b.bindI18nStore) || '' }) });
    return newOptions;
};

var withTolgee = function (i18n, tolgee) {
    i18n.use(tolgeeBackend(tolgee));
    i18n.use(tolgeeProcessor(tolgee));
    var originalInit = i18n.init;
    var newInit = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        tolgeeApply(tolgee, i18n);
        var options = {};
        var callback = undefined;
        if (typeof params[0] === 'object') {
            options = params[0];
            callback = params[1];
        }
        else {
            callback = params[0];
        }
        var newOptions = tolgeeOptions(tolgee, options);
        var result = originalInit(newOptions, callback);
        var language = i18n.language || options.lng;
        if (language) {
            tolgee.changeLanguage(language);
        }
        tolgee.run();
        return result;
    };
    i18n.init = newInit;
    return i18n;
};

var I18nextPlugin = function () { return function (tolgee) {
    tolgee.updateOptions({ ns: [], defaultNs: undefined });
    return tolgee;
}; };

export { I18nextPlugin, TOLGEE_PROCESSOR_NAME, tolgeeApply, tolgeeBackend, tolgeeOptions, tolgeeProcessor, withTolgee };
//# sourceMappingURL=tolgee-i18next.esm.js.map
